import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";

const i18nInit = (resources: Resource, region: string, lang: string) => {
  i18n.use(initReactI18next).init({
    lng: `${lang}-${region.toUpperCase()}`,
    resources,
    interpolation: {
      escapeValue: false,
      prefix: "{",
      suffix: "}"
    }
  });
};

export default i18nInit;
